import { apiPaths, queryKeyWithNpsn } from 'api/kinerja/kepala-sekolah/config'
import { useKinerjaApi } from 'api/kinerja/utils/api'

import type { PeriodOverride } from 'api/kinerja/kepala-sekolah/pelaksanaan'
import type { CommonMultiPeriodMeta } from 'types/kinerja'
import type { IPenilaianProgress } from 'types/kinerja-ks-pelaksanaan'
import type { CommonResponse } from 'types/api'
import type { UseQueryOptions } from 'react-query'

export const API_GET_KS_PENILAIAN_PROGRESS_QUERY_KEY =
  'API_GET_KS_PENILAIAN_PROGRESS_QUERY_KEY'

export function useApiGetPenilaianProgress(
  { npsn, ...override }: { npsn: string } & PeriodOverride,
  opts?: UseQueryOptions<CommonResponse<IPenilaianProgress>>
) {
  return useKinerjaApi<
    CommonResponse<IPenilaianProgress, CommonMultiPeriodMeta>
  >(`${apiPaths.penilaian}/progress`, {
    axiosConfig: {
      params: {
        npsn,
        ...override,
      },
    },
    queryConfig: {
      useErrorBoundary: false,
      ...opts,
    },
    queryKey: queryKeyWithNpsn(API_GET_KS_PENILAIAN_PROGRESS_QUERY_KEY, npsn),
  })
}
